import React, { useState, useEffect } from 'react';
import { useSecurityStatus } from '../../hooks/security';
import { OffCanvasPanel } from '../Shared/OffCanvasPanel';
import { getColors, removeData } from '../Shared/Functions';
import { AppBar, Badge, Button, Drawer, Toolbar } from '@mui/material';
import { withToast } from '../Shared/Toast';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Alerts } from './Alerts';

const DrawerComponent = ({ errorToast, alertMessage }) => {
    let [tertiary, setTertiary] = useState<string>("white");
    let [sidePanel, setSidePanel] = useState("offcanvas-collapse");  // Set to 'offcanvas-collapse-open' to open side panel
    let openSidePanel = (e) => setSidePanel(sidePanel === "offcanvas-collapse" ? "offcanvas-collapse-open" : "offcanvas-collapse");
    let { logout } = useSecurityStatus()
    const [open, setOpen] = useState<any>(true);

    useEffect(() => {
        getColors().then((x: any) => {
            setTertiary(x.tertiary)
        })
    }, [])

    const logoutCallback = () => {
        removeData("billingAccount")
        logout();
    }

    const handleExpandClick = () => { 
        setOpen(!open); 
     };

    return (
        <>
            <Drawer
                sx={{
                    '& .MuiDrawer-paper': {
                      boxSizing: 'border-box',
                    }
                  }}
                  open={sidePanel === "offcanvas-collapse-open"}
                  anchor="left">
                <OffCanvasPanel
                    sidePanel={sidePanel}
                    setSidePanel={setSidePanel}
                    logout={logoutCallback}
                    tertiary={tertiary}
                    fail={errorToast} />
            </Drawer>
            <AppBar position='fixed' color="secondary">
                <Toolbar>
                    <MenuIcon onClick={openSidePanel} />
                    {alertMessage &&
                        <Button onClick={handleExpandClick} sx={{ marginLeft: "auto" }}>
                            <Badge badgeContent={"!"} color="primary"><NotificationsIcon style={{ color: "black" }} /></Badge>
                        </Button>
                    }
                </Toolbar>
            </AppBar>
            <Toolbar />
            <Alerts open={open} alertMessage={alertMessage} />
        </>)
}

export default withToast(DrawerComponent)
